import React, { useState } from 'react';

// Firmanın hangi markaya ait olduğunu gösterir/değiştirir (bkz. server/utils/adminBrandScope.js).
// Admin sadece kapsamındaki markalar arasında seçim yapabilir; tek seçeneği varsa
// sadece rozet olarak görünür.
function BrandAssignSelect({ value, options, onChange }) {
  const [saving, setSaving] = useState(false);
  const current = value || 'ritsa';
  const label = options.find(o => o.key === current)?.label || current;

  const badgeStyle = {
    display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11.5, fontWeight: 600,
    padding: '3px 8px', borderRadius: 999, background: 'rgba(var(--primary-rgb), 0.1)',
    color: 'var(--primary)', border: '1px solid rgba(var(--primary-rgb), 0.3)'
  };

  if (options.length <= 1) return <span style={badgeStyle}>🎨 {label}</span>;

  return (
    <label style={{ ...badgeStyle, cursor: 'pointer', paddingRight: 4 }} title="Firmanın ait olduğu marka">
      🎨
      <select
        value={current}
        disabled={saving}
        onChange={async e => {
          const next = e.target.value;
          if (next === current) return;
          setSaving(true);
          try { await onChange(next); } finally { setSaving(false); }
        }}
        style={{ background: 'transparent', color: 'inherit', border: 'none', fontSize: 11.5, fontWeight: 600, cursor: 'pointer', outline: 'none' }}
      >
        {options.map(o => <option key={o.key} value={o.key} style={{ color: '#000' }}>{o.label}</option>)}
      </select>
    </label>
  );
}

export default BrandAssignSelect;
